document.addEventListener("DOMContentLoaded", () => {

    document
        .getElementById("calculate-loshu")
        .addEventListener("click", calculateReport);

});

async function calculateReport(){

    const day = parseInt(document.getElementById("loshu-day").value);

    const month = parseInt(document.getElementById("loshu-month").value);

    const year = parseInt(document.getElementById("loshu-year").value);

    if(!day || !month || !year){

        alert("Please select your complete Date of Birth");

        return;

    }

    const report = generateReport(day,month,year);

    await renderReport(report);

}

function generateReport(day,month,year){

    const dob = `${day}${month}${year}`;

    const digits = extractDigits(dob);

    const frequency = buildFrequency(digits);

    return{

        day,

        month,

        year,

        digits,

        frequency,

        personality:calculatePersonality(day),

        destiny:calculateDestiny(day,month,year),

        present:getPresentNumbers(frequency),

        missing:getMissingNumbers(frequency)

    };

}

function extractDigits(value){

    return value
        .split("")
        .map(Number)
        .filter(number=>number!==0);

}

function buildFrequency(digits){

    const frequency={};

    for(let i=1;i<=9;i++){

        frequency[i]=0;

    }

    digits.forEach(number=>{

        frequency[number]++;

    });

    return frequency;

}

function reduceNumber(number){

    while(number>9){

        number=number
            .toString()
            .split("")
            .reduce((a,b)=>a+Number(b),0);

    }

    return number;

}

function calculatePersonality(day){

    return reduceNumber(day);

}

function calculateDestiny(day,month,year){

    return reduceNumber(

        day+
        month+
        year

    );

}

function getPresentNumbers(frequency){

    return Object.keys(frequency)

        .filter(number=>frequency[number]>0)

        .map(Number);

}

function getMissingNumbers(frequency){

    return Object.keys(frequency)

        .filter(number=>frequency[number]===0)

        .map(Number);

}

async function renderReport(report){

    document.getElementById("loshu-result").style.display="block";

    document.getElementById("personality-number").textContent=report.personality;

    document.getElementById("destiny-number").textContent=report.destiny;

    renderGrid(report);

    renderNumbersUsed(report);

    await renderMissingNumbers(report);

    renderPresentNumbers(report);

    renderArrows(report);

    renderExploreNumbers();

}

function renderGrid(report){

    const grid = document.getElementById("loshu-grid");

    grid.innerHTML = "";

    const order = [4,9,2,3,5,7,8,1,6];

    order.forEach(number=>{

        const count = report.frequency[number];

        const cell = document.createElement("div");

        cell.className="grid-cell";

        if(count>0){

            cell.innerHTML=`
                <div class="grid-number">${String(number).repeat(count)}</div>
                <div class="grid-title">

<strong>${NUMBER_DATA[number].short}</strong>

<br>

<span>${NUMBER_DATA[number].title}</span>

</div>
            `;

        }else{

            cell.classList.add("missing");

            cell.innerHTML=`
                <div class="grid-number">${number}</div>
                <div class="grid-title">

<strong>${NUMBER_DATA[number].short}</strong>

<br>

<span>${NUMBER_DATA[number].title}</span>

</div>
            `;

        }

        grid.appendChild(cell);

    });

}

function renderNumbersUsed(report){

    const container=document.getElementById("numbers-used");

    container.innerHTML="";

    report.present.forEach(number=>{

        const count=report.frequency[number];

        const data=NUMBER_DATA[number];

        const card=document.createElement("div");

        card.className="number-card";

        card.innerHTML=`

            <h3>${number}</h3>

            <h4>${data.short}</h4>

            <p><strong>${count}</strong> occurrence(s)</p>

        `;

        container.appendChild(card);

    });

}

async function renderMissingNumbers(report){

    const container = document.getElementById("missing-numbers");

    container.innerHTML = "";

    for (const [index, number] of report.missing.entries()) {

        const data = NUMBER_DATA[number];

        const card = document.createElement("div");

        card.className = "number-card";

        let braceletHtml = "";

        if(data.bracelet){

            const product = await getProduct(data.bracelet.productHandle);

            if(product){

                const image = product.featured_image || product.images?.[0];

                braceletHtml = `

<div class="bracelet-card">

    <img
        src="${image}"
        class="bracelet-image"
    >

    <div class="bracelet-label">

        ✨ Recommended Bracelet

    </div>

    <div class="bracelet-name">

        ${product.title}

    </div>

    <div class="bracelet-price">

        ₹${(product.price/100).toLocaleString("en-IN")}

    </div>

    <a
        href="/products/${data.bracelet.productHandle}"
        class="bracelet-btn"
    >

        View Bracelet →

    </a>

</div>

`;
            }

        }

        card.innerHTML = `

            <h3>${number}</h3>

            <h4>${data.short}</h4>

            <div class="number-content">

                <p>${data.missing}</p>

            </div>

            ${braceletHtml}

        `;

        container.appendChild(card);

    }

}

function renderPresentNumbers(report){

    const container=document.getElementById("present-numbers");

    container.innerHTML="";

    report.present.forEach(number=>{

        const data=NUMBER_DATA[number];

        const card=document.createElement("div");

        card.className="number-card";

        card.innerHTML=`

<div class="number-header">

<div class="number-badge">${number}</div>

<div>

<h3>${data.short}</h3>

<p>${data.title}</p>

</div>

</div>

<hr>

<p><strong>Characteristic</strong></p>

<p>${data.characteristic}</p>

<br>

<p><strong>Prediction</strong></p>

<p>${data.prediction}</p>

<hr>

<p><b>Planet:</b> ${data.planet}</p>

<p><b>Element:</b> ${data.element}</p>

<p><b>Direction:</b> ${data.direction}</p>

<p><b>Colors:</b> ${data.colors}</p>

`;

        container.appendChild(card);

    });

}

function renderArrows(report){

    const present=document.getElementById("present-arrows");
    const missing=document.getElementById("missing-arrows");

    present.innerHTML="";
    missing.innerHTML="";

    let presentCount=0;

    ARROWS.forEach(arrow=>{

        const exists=arrow.numbers.every(n=>report.frequency[n]>0);

        const card=document.createElement("div");

        card.className="number-card";

        card.innerHTML=`

            <h3>${arrow.numbers.join(" → ")}</h3>

            <h4>${arrow.name}</h4>

            <p>${arrow.description}</p>

        `;

        if(exists){

            present.appendChild(card);
            presentCount++;

        }else{

            missing.appendChild(card);

        }

    });

    if(presentCount===0){

        present.innerHTML=`
            <div class="number-card">
                <h3>No Present Arrows</h3>
                <p>Your Lo Shu Grid currently doesn't form any complete arrows.</p>
            </div>
        `;

    }

}

function renderExploreNumbers(){

    const container=document.getElementById("number-meanings");

    container.innerHTML="";

    Object.keys(NUMBER_DATA).forEach(number=>{

        const data=NUMBER_DATA[number];

        const card=document.createElement("div");

        card.className="number-card";

        card.innerHTML=`

            <div class="number-header">

                <div class="number-badge">

                    ${number}

                </div>

                <div>

                    <h3>${data.short}</h3>

                    <p>${data.title}</p>

                </div>

            </div>

            <hr>

            <p><b>Planet:</b> ${data.planet}</p>

            <p><b>Element:</b> ${data.element}</p>

            <p><b>Direction:</b> ${data.direction}</p>

            <p><b>Colors:</b> ${data.colors}</p>

            <p><b>Body:</b> ${data.body}</p>

        `;

        container.appendChild(card);

    });

}

async function getProduct(productHandle){

    try{

        const response = await fetch(`/products/${productHandle}.js`);

        return await response.json();

    }catch(e){

        console.log(e);

        return null;

    }

}